import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/services/api.service';
import { Bill } from 'src/app/model/bill.model';
import { MatTableDataSource } from '@angular/material/table';
import { Payment } from '../billdetails/billdetails.component';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit, AfterViewInit {
  displayedPaymentColumns: string[] = [
    'paymentId',
    'billNumber',
    'custId',
    'paymentDate',
    'amountReceived',
    'paymentReceivedPhone',
    'textMessage',
    'textMessageBalance',
    'textAmountMsg',
    'paymentRemark',
    'badDebt',
    'discount',
    'dueAmount',
    'rh'
  ];
  pageSizes: number[] = [5];
  totalData = 0;
  isLoading = false;

  paymentDataSource = new MatTableDataSource<Payment>([]);

  bill : Bill;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    public dialogRef: MatDialogRef<PaymentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.fetchData(0, 50); // initial load
    this.bill = this.data.allBills.find((bill)=>bill.billNumber === this.data.bill.billNumber);
  }

  ngAfterViewInit(): void {
    this.paymentDataSource.paginator = this.paginator;
    this.paymentDataSource.sort = this.sort;
  }

  fetchData(pageIndex: number, pageSize: number) {
    this.isLoading = true;
    this.apiService.getBillPayments(this.data.bill, pageIndex, pageSize).subscribe({
      next: (res) => {
        this.totalData = res.totalItems;
        this.paymentDataSource.data = res.payments;
        this.isLoading = false;
      },
      error: () => {
        this._snackBar.open("Error fetching payments", "Close", { duration: 3000 });
        this.isLoading = false;
      }
    });
  }

  nextpage(event: any) {
    this.fetchData(event.pageIndex, event.pageSize);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
